<template>
  <div style="width: 100%; background:#ff00000d;padding:10px">
    <h3>Failure Type</h3>
      <div v-if="!onlyTable" style="width: 98%;">   
        <el-row  :gutter="10">
          <el-col :span="6">
            <el-form-item label="LEVEL 1"  label-width="120px" >
              <el-select v-model="level1" :placeholder="$t('msg.pleaseSelect')" @change="level1Change()" :no-data-text="$t('msg.noDataFound')" style="width:100%"> 
                <el-option v-for="item in level1Opts"  :key="item"  :label="item" :value="item" ></el-option>
              </el-select>
            </el-form-item>
          </el-col>  
          <el-col :span="6">
            <el-form-item label="LEVEL 2" label-width="120px">
              <el-select v-model="level2" :placeholder="$t('msg.pleaseSelect')" @change="level2Change()" :no-data-text="$t('msg.noDataFound')" style="width:100%">
                <el-option v-for="item in level2Opts"  :key="item"  :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="LEVEL 3" label-width="120px">
              <el-select v-model="level3" :placeholder="$t('msg.pleaseSelect')" :no-data-text="$t('msg.noDataFound')" style="width:100%" @change="level3Change()">
                <el-option v-for="item in level3Opts"  :key="item.key" :label="item.key" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>  
          <el-col :span="6">
            <el-form-item label="Defect Code" label-width="120px" >
              <el-input v-model="defectCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          
          <el-col :span="24">
            <el-form-item label="Comment" label-width="120px" >
              <el-input v-model="comment" maxlength=1000></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24" style="text-align: center;padding-bottom: 10px;">
          <el-button type="success" @click="addData"  size="small">{{$t('button.create')}}</el-button>
        </el-col>
      </div>
      <div style="width: 98%;">   
      <el-table ref="singleTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" id="failureStageTable">
        <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
          <template slot-scope="scope">          
            <span>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('action')" width=120px v-if="!onlyTable">
          <template slot-scope="scope">    
            <el-button type="danger" @click="delTableData(scope.row, scope.$index, true)">{{$t('button.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
  </div>
</template>

<script>
import {apiFindProductSelectedListByUserAttr,  apiFindFailureItemLevel1, 
        apiFindFailureItemLevel2, apiFindFailureItemLevel3,apiFindFeedbackFailureTypeByFeedbackId } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import CommonUtil from "../../../utils/commonUtil.js";


export default {
  props: {    
    pFeedbackId: {
      type: String
    },
    onlyTable: {
      type: Boolean,
      Default: false
    }
  },
  data() {   
    return { 
      level1:'',
      level2:'',
      level3:'',
      level1Opts:[],
      level2Opts:[],
      level3Opts:[],
      defectCode:'',
      comment:'',      
      tableData:{
        columns: [
          { field: "level1", title: 'LEVEL 1', width: 200 },         
          { field: "level2", title: 'LEVEL 2' , width: 200  },
          { field: "level3", title: 'LEVEL 3', width: 200  },
          { field: "defectCode", title: 'Defect Code', width: 200  },
          { field: "remark", title: 'Comment'}
        ],
        data: []
      },
    
    };
  },
  watch: {  
  },
  mounted() {    
    apiFindFailureItemLevel1({ headers: authHeader(), condition: 'Failure_Type_Level1'}).then((response) => {    
      response.data.forEach((item, index) => {   
        this.level1Opts.push(item.key);
      });
    }).catch((err) => {
      console.log(err);
    });
    if(this.pFeedbackId != null && this.pFeedbackId != ''){      
      apiFindFeedbackFailureTypeByFeedbackId({ headers: authHeader(), feedbackId: this.pFeedbackId}).then((response) => { 
        if(response.status== 200 && response.data != null && response.data.length > 0){
          this.tableData.data = response.data;
        }
      }).catch((err) => {
        console.log(err);
      });
    }
    
  },
  methods: {
    delTableData(row, index){  
      this.tableData.data.splice(index, 1);
    },
    addData(){      
      let isDuplicate = false;
      this.tableData.data.forEach((item, index) => {          
        if(item.level1 == this.level1 && item.level2 == this.level2 && 
          item.level3 == this.level3){
            isDuplicate = true;
        }
      });           
      if(isDuplicate){
        this.$message({ type: "error", message: this.$i18n.t('msg.isDuplicateCannotAdd'), duration: 800});
      }else{
       
        if(CommonUtil.isNull(this.level1) || CommonUtil.isNull(this.level2) || CommonUtil.isNull(this.level3) ){
          this.$message({ type: "warning", message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
          return;
        }        
      
        if(this.level3.indexOf('Other') >-1 && this.comment == ''){
          this.$message({ type: "warning", message: this.$i18n.t('msg.otherComment'), duration: 1000});
          return;
        } 
        let j = {
          level1: this.level1,
          level2: this.level2,
          level3: this.level3,
          defectCode:this.defectCode,
          remark: this.comment,
          action:'A'
        };
        this.tableData.data.splice(0, 0, j);
        this.currentIndex = 0;

        this.level1 = ''; 
        this.level2 = ''; 
        this.level3 = ''; 
        this.defectCode = '';
        this.comment = ''; 
      }
    },
    level1Change(){  
      this.level2Opts = [];
      this.level3Opts = [];    
      this.level2 = ''; 
      this.level3 = ''; 

      apiFindFailureItemLevel2({ headers: authHeader(), condition: this.level1}).then((response) => {            
        response.data.forEach((item, index) => {   
          this.level2Opts.push(item.key);
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    level2Change(){
      
      this.level3Opts = [];
      this.level3 = ''; 
      apiFindFailureItemLevel3({ headers: authHeader(), condition: this.level1,condition1: this.level2}).then((response) => {    
        
        response.data.forEach((item, index) => {   
          this.level3Opts.push({key:item.key, code:item.value});
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    findDefectCode(item, value) {
      return item.key === value;
    },
    level3Change(){

      this.level3;
      this.level3Opts.forEach((item, index) => {   
        if(item.key == this.level3){
          this.defectCode = item.code;
          return
        }
      });
    }
  }
};
</script>
